/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'
import { cn, getStoreCountry, useMarket } from '~/utils'
import { ApplePayIcon } from './ApplePayIcon'
import type { PaymentIconProps } from './common'
import { KlarnaIcon } from './KlarnaIcon'
import { MastercardIcon } from './MastercardIcon'
import { PaypalIcon } from './PaypalIcon'
import { ShopPayIcon } from './ShopPayIcon'
import { VippsIcon } from './VippsIcon'
import { VisaIcon } from './VisaIcon'

export interface PaymentIconsProps extends HTMLElementProps<'div'> {
	size: NonNullable<PaymentIconProps['size']>
}

export const PaymentIcons: React.FC<PaymentIconsProps> = ({ className, children, size, ...props }) => {
	const market = useMarket()
	return (
		<div className={cn('list flex h-12 items-center gap-2', className)} {...props}>
			{getStoreCountry() === 'NO' && <VippsIcon size={size} />}
			<KlarnaIcon size="small" />
			{market?.currency === 'EUR' ? <PaypalIcon size={size} /> : <ShopPayIcon />}
			<MastercardIcon size={size} />
			<VisaIcon size={size} />
			<ApplePayIcon size={size} />
			{children}
		</div>
	)
}
